import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=18b0c6cf&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b0c6cf')) {
      api.createRecord('18b0c6cf', component.options)
    } else {
      api.reload('18b0c6cf', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=18b0c6cf&", function () {
      api.rerender('18b0c6cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cC5CrA7NNyXF/JS/comp/ImgFallback.vue"
export default component.exports